import {ChildSimilarCaseDetected} from './child-similar-case-detected';

export class ChildSimilarCaseResponse {

    similar: boolean;
    cases: ChildSimilarCaseDetected[];

}
